<template>
  <div class="fertilizer">
    <div class="box">
      <img src="./loff.png">
      <br>LOFF
    </div>
    <div class="updated">20 VI 2005</div>
  </div>
</template>

<script>
export default {
  name: "loff"
};
</script>

<style scoped>
.fertilizer {
  background-color: #fff;
}

.box {
  margin-top: -60px;
  color: #8f0e2a;
  font-weight: bold;
}

.updated {
  color: #ccc;
}
</style>
